"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import {
  BookOpen,
  Key,
  BarChart3,
  Rocket,
  Code,
  LogOut,
  Play,
  Route,
} from "lucide-react";
import { useAuthStore } from "@/stores/auth";

const NAV_ITEMS = [
  { href: "/", label: "Overview", icon: Code },
  { href: "/keys", label: "API Keys", icon: Key },
  { href: "/playground", label: "Playground", icon: Play },
  { href: "/router", label: "Router", icon: Route },
  { href: "/docs", label: "Documentation", icon: BookOpen },
  { href: "/usage", label: "Usage", icon: BarChart3 },
  { href: "/quickstart", label: "Quickstart", icon: Rocket },
];

export function PlatformNav() {
  const pathname = usePathname();
  const { user, clearAuth } = useAuthStore();

  return (
    <nav className="border-b border-border bg-card/50 backdrop-blur-sm sticky top-0 z-50">
      <div className="mx-auto max-w-6xl flex items-center justify-between px-6 h-14">
        <div className="flex items-center gap-8">
          <Link href="/" className="flex items-center gap-2">
            <span className="text-lg font-bold">AIARVA</span>
            <span className="rounded-md bg-primary/10 px-2 py-0.5 text-xs font-medium text-primary">
              Platform
            </span>
          </Link>
          <div className="hidden md:flex items-center gap-1">
            {NAV_ITEMS.map(({ href, label, icon: Icon }) => {
              const active = pathname === href;
              return (
                <Link
                  key={href}
                  href={href}
                  className={`flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm transition-colors ${
                    active
                      ? "bg-accent text-foreground"
                      : "text-muted-foreground hover:text-foreground hover:bg-accent/50"
                  }`}
                >
                  <Icon className="h-4 w-4" />
                  {label}
                </Link>
              );
            })}
          </div>
        </div>
        {user && (
          <div className="flex items-center gap-3">
            <span className="text-sm text-muted-foreground">{user.email}</span>
            <button
              onClick={clearAuth}
              className="rounded-md p-1.5 text-muted-foreground hover:text-foreground hover:bg-accent"
              title="Sign out"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
